module.exports = __webpack_public_path__ + "78780b0d521cc7beb33fe2927393377e.jpg";